import { api } from '@/services/api/AxiosBaseService'
import type { PaginatedResponse } from '@/types/api'

/**
 * Blocos de conteúdo do Manual de Utilização. Cada bloco é um benefício:
 * ícone, título, subtítulo, texto, itens ("chips") e o fluxo de atendimento
 * (0800 → opção → etapas). O manual gerado traz só os blocos dos serviços
 * inclusos na proposta; bloco sem serviço é fixo (entra sempre).
 */
export interface ManualBlock {
  id: string
  coverageItemId: string | null
  coverageItemName?: string | null
  title: string
  subtitle?: string | null
  description?: string | null
  items: string[]
  phoneOption?: string | null
  flowSteps: string[]
  iconUrl?: string | null
  sortOrder?: number
  status: 'ATIVO' | 'INATIVO'
}

export interface ManualBlockPayload {
  proposal_coverage_item_id?: string | null
  title?: string
  subtitle?: string | null
  description?: string | null
  items?: string[]
  phone_option?: string | null
  flow_steps?: string[]
  sort_order?: number
  status?: 'ATIVO' | 'INATIVO'
}

export const ManualBlocksService = {
  async list(params: Record<string, unknown> = {}): Promise<PaginatedResponse<ManualBlock>> {
    const r = await api.get<PaginatedResponse<ManualBlock>>('/settings/manual-blocks', { params })
    return r.data
  },
  async show(id: string): Promise<ManualBlock> {
    const r = await api.get<{ data: ManualBlock }>(`/settings/manual-blocks/${id}`)
    return r.data.data
  },
  async create(payload: ManualBlockPayload): Promise<ManualBlock> {
    const r = await api.post<{ data: ManualBlock }>('/settings/manual-blocks', payload)
    return r.data.data
  },
  async update(id: string, payload: ManualBlockPayload): Promise<ManualBlock> {
    const r = await api.put<{ data: ManualBlock }>(`/settings/manual-blocks/${id}`, payload)
    return r.data.data
  },
  async destroy(id: string): Promise<void> {
    await api.delete(`/settings/manual-blocks/${id}`)
  },
  async updateStatus(id: string, status: 'ATIVO' | 'INATIVO'): Promise<ManualBlock> {
    const r = await api.put<{ data: ManualBlock }>(`/settings/manual-blocks/${id}/status`, { status })
    return r.data.data
  },
  /** Envia/substitui o ícone do bloco. */
  async uploadIcon(id: string, file: File): Promise<ManualBlock> {
    const fd = new FormData()
    fd.append('file', file)
    const r = await api.post<{ data: ManualBlock }>(`/settings/manual-blocks/${id}/icon`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return r.data.data
  },
}
